import { createActionGroup, props } from '@ngrx/store';
import { PresentationListResponse } from '../../../core/models/presentation.model';

export const PresentationsActions = createActionGroup({
  source: 'Presentations',
  events: {
    'Load Presentations': props<{ page: number; perPage: number }>(),
    'Load Presentations Success': props<{ response: PresentationListResponse }>(),
    'Load Presentations Failure': props<{ error: string }>(),
    'Download Presentation': props<{ id: string }>(),
  },
});
